import React from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { LanguageContext } from "../../context/LanguageContext";
import * as XLSX from "xlsx-js-style";
import {
  Button,
  Col,
  DatePicker,
  Descriptions,
  Dropdown,
  Form,
  Menu,
  message,
  Modal,
  PageHeader,
  Row,
  Select,
} from "antd";
import moment from "moment";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  DownOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { roleAction } from "../../_actions/roleby.action";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import _ from "lodash";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { Option } = Select;

const TableReportGunaAdmin = React.lazy(() =>
  import("./Tables/gunaTableAdmin").then((module) => ({
    default: module.TableReportGunaAdmin,
  })),
);

class GunaReportAdmin extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }

  state = {
    total: 0,
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    total: 0,
    showList: "list",
    guna_count: 0,
    download: "excel",
    crime_count: 0,
  };
  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
    }
  }

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    this.setState({
      report_4_endDate: date.toISOString(),
    });
  };
  getData = () => {
    const { showList } = this.state;
    if (showList === "list") {
      this.getListGunaReportAdmin();
    }
    if (showList === "count") {
      this.getCountGunaReportAdmin();
    }
  };
  getCountGunaReportAdmin = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    this.setState({
      loading: true,
    });
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    if (this.props.user.role === "4") {
      const temp = {
        startDate: startDate,
        endDate: endDate,
        city: this.props.user.cityId,
      };
      professionalAction.getCountGunaReportAdmin(temp).then((res) => {
        const data = res.results;
        const total = res.results.reduce(
          (acc, item) => acc + item.register_count,
          0,
        );

        this.setState({
          report4_List: data,
          total: total,
          loading: false,
        });
      });
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      const temp = {
        startDate: startDate,
        endDate: endDate,
        districtId: this.props.user.map_districtId,
      };
      roleAction.getCountGunaReportByRole(temp).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;

            const total = list.reduce(
              (acc, item) => acc + item.register_count,
              0,
            );
            this.setState({
              report4_List: list,
              total: total,
              loading: false,
            });
          });
      });
    }
  };
  getListGunaReportAdmin = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    this.setState({
      loading: true,
    });
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");

    if (this.props.user.role === "4") {
      const temp = {
        startDate: startDate,
        endDate: endDate,
        city: this.props.user.cityId,
      };
      professionalAction.getListGunaReportAdmin(temp).then((res) => {
        this.setState({
          report4_List: res.results,
          loading: false,
        });
      });
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      const temp = {
        startDate: startDate,
        endDate: endDate,
        districtId: this.props.user.map_districtId,
      };
      roleAction.getListGunaReportByRole(temp).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;

            this.setState({
              report4_List: list,

              total: list.length,
              loading: false,
            });
          });
      });
    }
  };
  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return this.state.showList === "list"
      ? arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("district_name")]: data.districtName,
          [t("Total_registerNumber")]: data.Total_registerNumber,
          [t("total_accused")]: data.Total_accused,
        })) || []
      : arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("district_name")]: data.DistrictName,
          [t("total_accused")]: data.Total_accused_count,
          [t("total_crimes")]: data.Total_gunhe_count,
          शरीराविषयक: data.shariravishayak,
          मालाविषयक: data.malavishayak,
          "अवैध वाळू विषयक": data.avaidh_valu,
          "अवैध दारु विषयक": data.avaidh_daru,
          जुगारविषयक: data.jugarvishayak,
          महिलाविषयक: data.mahilavishayak,
          इतर: data.itar,
          "अवैध अमली पदार्थ": data.avaidh_amli_padarth,
          "अवैध शस्त्रे": data.avaidh_shastre,
        })) || [];
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("guna_register");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    console.log("this.props", this.props);
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;

    if (download === "excel") {
      this.download_csv();
    }
    if (download === "pdf") {
      this.download_pdf();
    }
  };
  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  download_csv = () => {
    this.props.dispatch(professionalAction.getCity());
    const { showList } = this.state;
    const { t } = this.context;

    var ReportTitle = t("guna_register");
    var title = t("guna_register");
    var arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      showList === "list"
        ? arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("district_name")]: data.districtName,
            [t("Total_registerNumber")]: data.Total_registerNumber,
            [t("total_accused")]: data.Total_accused,
          }))
        : arrData1.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("district_name")]: data.DistrictName,
            [t("total_accused")]: data.Total_accused_count,
            [t("total_crimes")]: data.Total_gunhe_count,
            शरीराविषयक: data.shariravishayak,
            मालाविषयक: data.malavishayak,
            "अवैध वाळू विषयक": data.avaidh_valu,
            "अवैध दारु विषयक": data.avaidh_daru,
            जुगारविषयक: data.jugarvishayak,
            महिलाविषयक: data.mahilavishayak,
            इतर: data.itar,
            "अवैध अमली पदार्थ": data.avaidh_amli_padarth,
            "अवैध शस्त्रे": data.avaidh_shastre,
          }));
    const arrData = list;
    // ===================== STYLES =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: {
        horizontal: "center",
        vertical: "top", // ✅ IMPORTANT
        wrapText: true,
      },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ===================== WORKBOOK =====================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    const cityName = this.getCityName(this.props.user.cityId);

    const headerData = cityName;
    console.log("professionals", this.props && this.props.professionals);

    // ===================== TITLES =====================
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });

    if (!ws["A1"]) ws["A1"] = { t: "s", v: headerData };
    ws["A1"].s = titleStyle;

    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });

    if (!ws["A2"]) ws["A2"] = { t: "s", v: ReportTitle };
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    // ===================== TABLE HEADERS (A3) =====================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ===================== TABLE DATA (A4) =====================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ===================== FOOTER =====================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ===================== FORMATTING =====================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];

    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }

    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };

    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    // ===================== EXPORT =====================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  onViewAccusedForm = (data) => {
    let obj = {
      id: data,
    };
    if (data) {
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };
  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };

  render() {
    const { report_4_startDate, report_4_endDate, showList, key, direction } =
      this.state;
    const { language, t } = this.context;
    const { professionals } = this.props;
    console.log("this props guna report", this.props);
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        {this.state.showList == "list" ? (
          <>
            <Menu.Item key="Total_registerNumber">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकुण गुन्हे
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "Total_registerNumber" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_registerNumber", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "Total_registerNumber" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_registerNumber", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
            <Menu.Item key="Total_accused">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकूण आरोपी
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "Total_accused" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_accused", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "Total_accused" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_accused", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item key="Total_accused_count">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकूण आरोपी
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "Total_accused_count" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_accused_count", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "Total_accused_count" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_accused_count", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
            <Menu.Item key="Total_gunhe_count">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकुण गुन्हे
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "Total_gunhe_count" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_gunhe_count", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "Total_gunhe_count" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("Total_gunhe_count", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    );
    return (
      <>
        <PageHeader
          className="site-page-header"
          ghost={false}
          onBack={false}
          title={t("guna_register")}
        >
          <Row gutter={[16, 16]} align="middle">
            {/* Start Date Picker */}
            <Col xs={24} sm={12} md={6} lg={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={report_4_startDate ? moment(report_4_startDate) : null}
                onChange={this.onStartDateChange}
                placeholder="DD/MM/YYYY"
                allowClear
                format="DD/MM/YYYY"
                inputReadOnly
              />
            </Col>

            {/* End Date Picker */}
            <Col xs={24} sm={12} md={6} lg={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={report_4_endDate ? moment(report_4_endDate) : null}
                onChange={this.onEndDateChange}
                placeholder="DD/MM/YYYY"
                allowClear
                format="DD/MM/YYYY"
                inputReadOnly
              />
            </Col>

            {/* Find Button */}
            <Col xs={24} sm={24} md={6} lg={3}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                disabled={
                  !this.state.report_4_startDate || !this.state.report_4_endDate
                }
                onClick={this.getData}
              >
                {t("find")}
              </Button>
            </Col>

            {/* Download Select */}
            <Col xs={24} sm={12} md={4} lg={3}>
              <Select
                placeholder={t("please_select_an_option")}
                value={this.state.download || "excel"}
                onChange={(value) => this.setState({ download: value })}
                style={{ width: "100%" }}
                loading={this.state.downloadLoding}
              >
                <Option key="excel">{t("excel")}</Option>
                <Option key="pdf">PDF</Option>
              </Select>
            </Col>

            {/* Download Button */}
            <Col xs={24} sm={12} md={4} lg={3}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={this.downloadReport}
                disabled={!this.state.report4_List?.length}
              >
                {t("download")}
              </Button>
            </Col>
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              arrow
              disabled={!this.state.report4_List?.length}
            >
              <Button type="ghost">
                {t("sorter_by")} <DownOutlined />
              </Button>
            </Dropdown>
          </Row>
        </PageHeader>
        <React.Suspense fallback={<div>Loading...</div>}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
              padding: "12px",
              background: "#f5f5f5",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {" "}
              <Button
                type={showList == "count" ? "primary" : "default"}
                icon={<BarChartOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  this.setState({
                    showList: "count",
                    report4_List: [],
                  });
                }}
              >
                {t("statistics")}
              </Button>
              <Button
                type={showList == "list" ? "primary" : "default"}
                icon={<UnorderedListOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  this.setState({
                    showList: "list",
                    report4_List: [],
                  });
                }}
              >
                {t("list")}
              </Button>
            </div>
          </div>

          <TableReportGunaAdmin
            key={this.state.report4_List}
            data={this.state.report4_List}
            total={this.state.total}
            startDate={this.state.report_4_startDate}
            endDate={this.state.report_4_endDate}
            district={this.props.user.districtId}
            showList={this.state.showList}
            guna_count={this.state.guna_count}
            crime_count={this.state.crime_count}
            city={this.props.user.cityId}
            onViewAccusedForm={this.onViewAccusedForm}
            loading={this.state.loading}
            professionals={this.props.professionals}
            user={this.props.user}
          ></TableReportGunaAdmin>
          <Modal
            title="आरोपी प्रोफाइल"
            top
            visible={this.state.setCriminalViewModel}
            onOk={this.closeCriminalViewModel}
            onCancel={this.closeCriminalViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              key={this.props && this.props.user.id}
              dataStates={professionals}
            ></ViewFormModel>
          </Modal>
        </React.Suspense>
      </>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedGunaReportAdmin = connect(mapStateToProps)(GunaReportAdmin);
export { connectedGunaReportAdmin as GunaReportAdmin };
